import CollaborationCloseIcon from '@/assets/Icons/components/CollaborationCloseIcon';
import Button from '@/components/Button/Button';
import { useState, useEffect } from 'react';
import { CollaborationPopupProps } from './PopupTypes';

const CollaborationPopup = ({ isVisible, onClose }: CollaborationPopupProps) => {
  const [isShowing, setIsShowing] = useState(isVisible);

  useEffect(() => {
    setIsShowing(isVisible);
  }, [isVisible]);

  if (!isShowing) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 max-w-md mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className=" font-semibold text-ds-gray-700">Collaboration in Progress</h3>
          <div className="cursor-pointer" onClick={onClose}>
            <CollaborationCloseIcon />
          </div>
        </div>

        <p className="mb-6 text-sm text-ds-gray-700">
          Another person is currently editing this section. To avoid conflicts, please ensure your
          changes don’t overlap or communicate with the other collaborator.
        </p>
        <Button color="primary" widthFull={true} onClick={onClose}>
          Got it!
        </Button>
      </div>
    </div>
  );
};

export default CollaborationPopup;
